import styled from "styled-components";

const StyledReferenceText = styled.span`
  font-size: 3rem;
  font-weight: 600;
`;

export default StyledReferenceText;
